import React from 'react';
import { VisitaGuiada } from '../../../domain/entities/VisitaGuiada';
import { APP_CONFIG } from '../../../shared/constants/AppConfig';
import './VisitaGuiadaCard.css';
import { GoogleCalendarButton } from '../GoogleCalendarButton';

interface VisitaGuiadaCardProps {
  visita: VisitaGuiada;
  compact?: boolean;
}

export const VisitaGuiadaCard: React.FC<VisitaGuiadaCardProps> = ({ visita, compact }) => {
  // Monta o título e descrição do evento
  const title = `${APP_CONFIG.ORGANIZATION_NAME} - Visita Guiada`;
  const description = 'Participe da visita guiada!';
  // Data e hora em formato YYYYMMDDTHHmmssZ
  const startDate = new Date(visita.date.value);
  const [hours, minutes] = visita.time.value.split(':');
  startDate.setHours(Number(hours), Number(minutes), 0, 0);
  // Considera duração padrão de 30m
  const endDate = new Date(startDate.getTime() + 30 * 60 * 1000);
  function formatDateForGoogle(date: Date) {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  }
  const dates = `${formatDateForGoogle(startDate)}/${formatDateForGoogle(endDate)}`;
  const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${dates}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(APP_CONFIG.ADDRESS)}`;

  return (
    <div className={`visita-guiada-card${compact ? ' compact' : ''}`}>
      <div className="visita-content">
        <div className="visita-info-row">
          <div>
            <h3 className="visita-date">{visita.getFormattedDate()}</h3>
            <p className="visita-time">{`${visita.getWeekday()}, ${visita.time.value}`}</p>
          </div>
          <GoogleCalendarButton url={googleCalendarUrl} className="google-calendar-btn" title="Adicionar ao Google Calendar" />
        </div>
      </div>
    </div>
  );
}; 